import ExcelJs from "exceljs"

// STYLES

const style = {}

style.ratesHeader = {
  font: {
    name: 'Franklin Gothic Book',
    family: 2,
    size: 10,
    color: { argb: 'FF000000' },
    bold: true
  }
}

style.reportTitle = {
  font: {
    name: 'Constantia',
    family: 2,
    size: 18,
    color: { argb: 'FFFFFFFF' },
  },
  fill: {
    type: 'pattern',
    pattern:'solid',
    fgColor: { argb:'FF454545' }
  },
  alignment: {
    vertical: 'bottom',
    horizontal: 'left',
    indent: 1
  }
}

style.reportSubtitle = {
  font: {
    name: 'Franklin Gothic Book',
    family: 2,
    size: 11,
    color: { argb: 'FFFFFFFF' },
  },
  fill: {
    type: 'pattern',
    pattern:'solid',
    fgColor: { argb:'FF454545' }
  },
  alignment: {
    vertical: 'top',
    horizontal: 'left',
    indent: 1
  }
}

style.reportSummaryTitle = {
  font: {
    name: 'Franklin Gothic Book',
    family: 2,
    size: 10,
    color: { argb: 'FF333A56' },
  },
  alignment: {
    vertical: 'middle',
    horizontal: 'left',
    indent: 1
  }
}

style.reportSummaryValue = {
  font: {
    name: 'Franklin Gothic Book',
    family: 2,
    size: 10,
    color: { argb: 'FF333A56' },
    bold: true
  },
  fill: {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb:'FFC6D9F1' }
  },
  alignment: {
    horizontal: 'center',
    vertical: 'middle'
  }
}

style.reportHeader = {
  fill: {
    type: 'pattern',
    pattern:'solid',
    fgColor: { argb:'FF1F497D' }
  },
  font: {
    name: 'Franklin Gothic Book',
    family: 2,
    size: 10,
    color: { argb: 'FFFFFFFF' },
  },
  alignment: {
    vertical: 'middle',
    horizontal: 'center'
  },
  border: {
    left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
    right: { style: 'thin', color: { argb: 'FFFFFFFF' } }
  }
}

style.reportClient = {
  font: {
    name: 'Franklin Gothic Book',
    family: 2,
    size: 12,
    color: { argb: 'FF000000' },
  },
  alignment: {
    horizontal: 'left',
    vertical: 'middle',
    indent: 1,
  }
}

style.reportRecord = {
  font: {
    name: 'Franklin Gothic Book',
    family: 2,
    size: 9,
    color: { argb: 'FF000000' },
  },
  alignment: {
    horizontal: 'right',
    vertical: 'middle',
    indent: 1,
  }
}

style.reportError = {
  fill: {
    type: 'pattern',
    pattern:'solid',
    fgColor: { argb:'FFFF0000'}
  },
  border: {
    top: { style: 'thin', color: { argb: 'FF999999'} },
    left: { style: 'thin', color: { argb: 'FF999999'} },
    bottom: { style: 'thin', color: { argb: 'FF999999'} },
    right: { style: 'thin', color: { argb: 'FF999999'} },
  }
}

style.reportValue = {
  font: {
    name: 'Franklin Gothic Book',
    family: 2,
    size: 9,
    color: { argb: 'FF000000' },
  },
  fill: {
    type: 'pattern',
    pattern:'solid',
    fgColor: { argb:'FFF2F2F2'}
  },
  border: {
    top: { style: 'thin', color: { argb: 'FFFFFFFF'} },
    left: { style: 'thin', color: { argb: 'FFFFFFFF'} },
    bottom: { style: 'thin', color: { argb: 'FFFFFFFF'} },
    right: { style: 'thin', color: { argb: 'FFFFFFFF'} },
  },
  alignment: {
    horizontal: 'center',
    vertical: 'middle',
  }
}

style.reportTotalTitle = {
  font: {
    name: 'Franklin Gothic Book',
    family: 2,
    size: 10,
    color: { argb: 'FF1F497D' },
  },
  alignment: {
    horizontal: 'right',
    vertical: 'middle',
    indent: 1,
  }
}

style.reportTotalValue = {
  font: {
    name: 'Franklin Gothic Book',
    family: 2,
    size: 9,
    color: { argb: 'FF000000' },
  },
  fill: {
    type: 'pattern',
    pattern:'solid',
    fgColor:{argb:'FFC6D9F1'}
  },
  border: {
    top: { style: 'thin', color: { argb: 'FFFFFFFF'} },
    left: { style: 'thin', color: { argb: 'FFFFFFFF'} },
    bottom: { style: 'thin', color: { argb: 'FFFFFFFF'} },
    right: { style: 'thin', color: { argb: 'FFFFFFFF'} },
  },
  alignment: {
    vertical: 'middle',
    horizontal: 'center'
  }
}

style.reportTotalBoldValue = {
  font: {
    name: 'Franklin Gothic Book',
    family: 2,
    size: 9,
    color: { argb: 'FF000000' },
    bold: true,
  },
  fill: {
    type: 'pattern',
    pattern:'solid',
    fgColor:{argb:'FFC6D9F1'}
  },
  border: {
    top: { style: 'thin', color: { argb: 'FFFFFFFF'} },
    left: { style: 'thin', color: { argb: 'FFFFFFFF'} },
    bottom: { style: 'thin', color: { argb: 'FFFFFFFF'} },
    right: { style: 'thin', color: { argb: 'FFFFFFFF'} },
  },
  alignment: {
    vertical: 'middle',
    horizontal: 'center'
  }
}

// FUNCS

function setCell(cell, value, ...sources) {
  for (let i = 0; i < sources.length; i++) {
    const source = sources[i];
    for (let key in source) {
      cell[key] = source[key];
    }
  }
  cell.value = value;
  return cell;
}

function mapCurrencies(currencies, referenceCurrency = 'RUB') {
  const ref = currencies.find(c => c.id === referenceCurrency);
  var result = {}
  for (let i = 0; i < currencies.length; i++) {
    const currency = currencies[i];
    currency.rateTo1Ref = 1 / (currency.rateTo1Usd / ref.rateTo1Usd);
    result[currency.id] = currency;
  }
  result['[NOTFOUND]'] = {
    decimals: 8,
    description: `[NOTFOUND]`,
    gameDenomination: 1,
    id: '[NOTFOUND]',
    rateTo1Usd: 0,
    rateTo1Ref: 0,
    symbol: `[NOTFOUND]`,
    notFound: true
  };
  return result
}

function getValFormat(currency) {
  let result = '#,##0';
  const dec = currency ? currency.decimals : 8;
  for (let i = 0; i < dec; i++) {
    if (i === 0) result += '.';
    result += '0';
  }
  return result;
}

function getCurrency(currencyDict, id) {
  return currencyDict[id]
    ? currencyDict[id]
    : currencyDict['[NOTFOUND]'];
}

function getMoney(value, currency) {
  return value * Math.pow(10, -currency.decimals)
}

// SHEETS

function createReportSheet(sheet, search, clients, report, currencyDict, refCurrency, refFormat) {
  const percFormat = '#0.00%';

  sheet.getColumn(1).width = 2;
  sheet.getColumn(2).width = 22;
  sheet.getColumn(3).width = 14;
  sheet.getColumn(4).width = 14;
  sheet.getColumn(5).width = 14;
  sheet.getColumn(6).width = 14;
  sheet.getColumn(7).width = 14;
  sheet.getColumn(8).width = 2;

  const brandRow = sheet.getRow(2);
  brandRow.height = 30;
  setCell(
    brandRow.getCell(2),
    "Bet`N Go",
    style.reportTitle);
  sheet.mergeCells(2, 2, 2, 7);

  const titleRow = sheet.getRow(3);
  titleRow.height = 20;
  setCell(
    titleRow.getCell(2),
    'Profit & Loss Statement (' + search.method + ')',
    style.reportTitle);
  sheet.mergeCells(3, 2, 3, 7);

  const subTitleRow = sheet.getRow(4);
  subTitleRow.height = 20;
  setCell(
    subTitleRow.getCell(2),
    `For the [${search.timeFrom.format('YYYY/MM/DD')}] that ended [${search.timeTo.format('YYYY/MM/DD')}], created [${search.timeNow.format('YYYY/MM/DD HH:mm:ss z')}]`,
    style.reportSubtitle);
  sheet.mergeCells(4, 2, 4, 7);

  const summaryRow = sheet.getRow(6);
  summaryRow.height = 17;
  setCell(
    summaryRow.getCell(2),
    "Net Profit",
    style.reportSummaryTitle);
  const summaryCell = setCell(summaryRow.getCell(3),
    0,
    style.reportSummaryValue,
    { numFmt: refFormat });
  sheet.mergeCells(6, 3, 6, 7);

  const headerRow = sheet.getRow(8);
  headerRow.height = 50;
  setCell(
    headerRow.getCell(3),
    "Sales",
    style.reportHeader);
  setCell(
    headerRow.getCell(4),
    "Redeems",
    style.reportHeader);
  setCell(
    headerRow.getCell(5),
    "Hold",
    style.reportHeader);
  setCell(
    headerRow.getCell(6),
    `Hold (${refCurrency})`,
    style.reportHeader);
  setCell(
    headerRow.getCell(7),
    "% Hold",
    style.reportHeader);

  const holdSummaryTerms = [];

  let curRow = 9;
  for (var ci = 0; ci < report.length; ci++) {
    const clientReport = report[ci];
    const client = clients.find(c => c.id === clientReport.clientId);

    const inTotalTerms = [];
    const outTotalTerms = [];

    const clientRow = sheet.getRow(curRow++)
    clientRow.height = 30;
    setCell(
      clientRow.getCell(2),
      client.name,
      style.reportClient);

    for (var mi = 0; mi < clientReport.totals.length; mi++) {
      const methodReport = clientReport.totals[mi];
      for (var curi = 0; curi < methodReport.currencies.length; curi++) {
        const currencyReport = methodReport.currencies[curi];

        const currency = getCurrency(currencyDict, currencyReport.currency);
        const valFormat = getValFormat(currency);
        const rowStyle = currency.notFound ? style.reportError : {}

        const row = sheet.getRow(curRow++);
        setCell(
          row.getCell(2),
          `${currencyReport.currency}${(currency.notFound ? ' [NOTFOUND]' : '')}`,
          style.reportRecord,
          rowStyle);
        const inCell = setCell(
          row.getCell(3),
          getMoney(currencyReport.in, currency),
          style.reportValue,
          { numFmt: valFormat },
          rowStyle);
        const outCell = setCell(
          row.getCell(4),
          getMoney(currencyReport.out, currency),
          style.reportValue,
          { numFmt: valFormat },
          rowStyle);
        const holdCell = setCell(
          row.getCell(5),
          { formula: `${inCell.address}-${outCell.address}` },
          style.reportValue,
          { numFmt: valFormat },
          rowStyle);
        setCell(
          row.getCell(6),
          { formula: `${holdCell.address}*'rates'!${currency.address}` },
          style.reportValue,
          { numFmt: refFormat },
          rowStyle);
        setCell(
          row.getCell(7),
          { formula: `IF(${inCell.address}=0,"",${holdCell.address}/${inCell.address}` },
          style.reportTotalValue,
          { numFmt: percFormat },
          rowStyle);

          inTotalTerms.push(`${inCell.address}*'rates'!${currency.address}`);
          outTotalTerms.push(`${outCell.address}*'rates'!${currency.address}`);
      }
    }

    const totalRow = sheet.getRow(curRow++);
    totalRow.height = 30;
    const hasTotal = inTotalTerms.length > 0;
    setCell(
      totalRow.getCell(2),
      'Total',
      style.reportTotalTitle);
    const inCell = setCell(
      totalRow.getCell(3),
      hasTotal ? { formula: inTotalTerms.join('+') } : 0,
      style.reportTotalValue,
      { numFmt: refFormat });
    const outCell = setCell(
      totalRow.getCell(4),
      hasTotal ? { formula: outTotalTerms.join('+') } : 0,
      style.reportTotalValue,
      { numFmt: refFormat });
    const holdCell = setCell(
      totalRow.getCell(5),
      hasTotal ? { formula: `${inCell.address}-${outCell.address}` } : 0,
      style.reportTotalValue,
      { numFmt: refFormat });
    setCell(
      totalRow.getCell(6),
      hasTotal ? { formula: `${inCell.address}-${outCell.address}` } : 0,
      style.reportTotalBoldValue,
      { numFmt: refFormat });
    setCell(
      totalRow.getCell(7),
      hasTotal ? { formula: `IF(${inCell.address}=0,"",${holdCell.address}/${inCell.address})` } : "",
      style.reportTotalValue,
      { numFmt: percFormat });

    if (hasTotal) holdSummaryTerms.push(holdCell.address);
  }

  setCell(
    summaryCell,
    { formula: holdSummaryTerms.join('+') });

  const firstCell = sheet.getRow(1).getCell(1);
  const lastCell = sheet.getRow(curRow).getCell(8);
  sheet.pageSetup.printArea = `${firstCell.address}:${lastCell.address}`;
}

function createRatesSheet (sheet, currencyDict, refCurrency) {
  sheet.getColumn(1).width = 20;
  sheet.getColumn(2).width = 20;

  const dateRow = sheet.getRow(1);
  setCell(
    dateRow.getCell(1),
    'Date',
    style.ratesHeader);
  setCell(
    dateRow.getCell(2),
    '0001-01-01 00:00:00');

  const refRow = sheet.getRow(3);
  setCell(
    refRow.getCell(2),
    refCurrency,
    style.ratesHeader);

  let curRowNum = 4;
  for (let key in currencyDict) {
    const curRow = sheet.getRow(curRowNum++);

    setCell(
      curRow.getCell(1),
      key,
      style.ratesHeader);
    const rateCell = setCell(
      curRow.getCell(2),
      currencyDict[key].rateTo1Ref);

    currencyDict[key].address = rateCell.address
  }
  return currencyDict;
}

export default {
  async createXlsx ({search, clients, currencies, report, refCurrency, refFormat}) {
    let currencyDict = mapCurrencies(currencies, refCurrency);
    const workbook = new ExcelJs.Workbook();
    const reportSheet = workbook.addWorksheet("report");
    const ratesSheet = workbook.addWorksheet("rates");
    currencyDict = createRatesSheet(ratesSheet, currencyDict, refCurrency);
    createReportSheet(reportSheet, search, clients, report, currencyDict, refCurrency, refFormat);
    const buffer = await workbook.xlsx.writeBuffer();
    return buffer;
  }
}


// WEBPACK FOOTER //
// ./src/services/statsClients.service.js